const customersEn = {
  "nav.segments": "Segments",
  "nav.privacy_requests": "Privacy requests",
  "common.edit": "Edit",
  "settings.customer_accounts": "Customer accounts",
  "settings.customer_accounts_hint": "How shoppers sign in to your store",

  "cust.title": "Customers",
  "cust.all": "All",
  "cust.add": "Add customer",
  "cust.import": "Import",
  "cust.export": "Export",
  "cust.search": "Search by name, email or phone",
  "cust.count": "{n} customers",
  "cust.none_match": "No customers match these filters.",
  "cust.empty_title": "Everyone who shops with you, in one place",
  "cust.empty_body": "Customers appear here when they check out or create an account. You can also add them yourself or import a spreadsheet.",
  "cust.no_name": "No name",
  "cust.filter.tag": "Tag",
  "cust.filter.email": "Email subscription",
  "cust.filter.state": "Account",
  "cust.col.name": "Customer",
  "cust.col.subscription": "Email subscription",
  "cust.col.location": "Location",
  "cust.col.orders": "Orders",
  "cust.col.spent": "Amount spent",
  "cust.sort.-created_at": "Newest",
  "cust.sort.created_at": "Oldest",
  "cust.sort.-updated_at": "Recently updated",
  "cust.sort.name": "Name A–Z",
  "cust.sort.-amount_spent": "Highest spend",
  "cust.sort.-orders_count": "Most orders",
  "cust.sub.subscribed": "Subscribed",
  "cust.sub.not_subscribed": "Not subscribed",
  "cust.sub.pending": "Pending confirmation",
  "cust.sub.unsubscribed": "Unsubscribed",
  "cust.state.enabled": "Active account",
  "cust.state.disabled": "Disabled",
  "cust.state.invited": "Invited",
  "cust.state.declined": "Declined invite",
  "cust.channel.email": "Email",
  "cust.channel.sms": "SMS",
  "cust.channel.whatsapp": "WhatsApp",
  "cust.src.checkout": "Checkout",
  "cust.src.account": "Customer account",
  "cust.src.admin": "Admin",
  "cust.src.import": "Import",
  "cust.src.form": "Signup form",
  "cust.src.merge": "Merge",
  "cust.src.api": "API",

  "cust.new_title": "New customer",
  "cust.overview": "Customer overview",
  "cust.first_name": "First name",
  "cust.last_name": "Last name",
  "cust.email": "Email",
  "cust.phone": "Phone",
  "cust.phone_hint": "Local numbers use your store's country code.",
  "cust.language": "Language",
  "cust.language_store": "Store default",
  "cust.consent_email": "Customer agreed to receive marketing emails",
  "cust.consent_sms": "Customer agreed to receive marketing text messages",
  "cust.consent_note": "Only tick these if the customer gave you permission. Consent changes are recorded.",
  "cust.address": "Address",
  "cust.add_address": "Add address",
  "cust.address_optional": "Optional. Customers can also add addresses at checkout.",
  "cust.tags": "Tags",
  "cust.notes": "Notes",
  "cust.notes_placeholder": "Only staff can see notes.",

  "cust.since": "Added {when}",
  "cust.more": "More actions",
  "cust.pii_masked": "Contact details are hidden. Ask the store owner for permission to view customer contact details.",
  "cust.erased_banner": "This customer's personal data was erased on {date}. Their orders stay for your records.",
  "cust.stat.spent": "Amount spent",
  "cust.stat.orders": "Orders",
  "cust.stat.aov": "Average order",
  "cust.stat.last_order": "Last order",
  "cust.orders": "Orders",
  "cust.no_orders": "No orders yet",
  "cust.no_orders_body": "This customer's orders will show here.",
  "cust.contact": "Contact",
  "cust.no_email": "No email",
  "cust.no_phone": "No phone",
  "cust.edit_contact": "Edit contact details",
  "cust.default_address": "Default address",
  "cust.addresses": "Addresses",
  "cust.manage": "Manage",
  "cust.no_address": "No address saved.",
  "cust.more_addresses": "+{n} more",
  "cust.edit_address": "Edit address",
  "cust.make_default": "Set as default",
  "cust.default": "Default",
  "cust.delete_address": "Delete this address?",
  "cust.marketing": "Marketing",
  "cust.history": "History",
  "cust.subscribe": "Subscribe",
  "cust.unsubscribe": "Unsubscribe",
  "cust.consent_confirm_title": "Did the customer agree?",
  "cust.consent_confirm_body": "Only subscribe customers who gave you permission to send them marketing. The change is recorded in their consent history.",
  "cust.consent_history": "Consent history",
  "cust.no_consents": "No consent changes recorded.",
  "cust.when": "When",
  "cust.change": "Change",
  "cust.source": "Source",
  "cust.tax": "Taxes",
  "cust.tax_exempt": "Collect no tax from this customer",
  "cust.exemption_codes": "Exemption codes",
  "cust.duplicates": "Possible duplicates",
  "cust.duplicates_hint": "These customers look like the same person. Merge them to keep one history.",
  "cust.dup.same_email": "Same mailbox",
  "cust.dup.same_phone": "Same phone number",
  "cust.dup.similar_name_same_address": "Similar name, same address",
  "cust.timeline": "Timeline",
  "cust.comment_placeholder": "Leave a comment…",
  "cust.comment_hint": "Only staff can see comments.",
  "cust.post": "Post",
  "cust.staff": "Staff",
  "cust.edited": "edited",
  "cust.delete_comment": "Delete this comment?",

  "cust.send_invite": "Send account invite",
  "cust.invite_title": "Send an account invite?",
  "cust.invite_body": "We'll email {email} a link to activate their account.",
  "cust.invite_sent": "Invite sent.",
  "cust.disable": "Disable account",
  "cust.enable": "Enable account",
  "cust.disable_title": "Disable this account?",
  "cust.disable_body": "The customer is signed out everywhere and can't sign in until you enable the account again. Their orders aren't affected.",
  "cust.data_export": "Export customer data",
  "cust.data_export_title": "Export this customer's data?",
  "cust.data_export_body": "We'll prepare a file with everything stored about this customer. You can download it from the privacy card for 24 hours.",
  "cust.data_export_started": "Preparing the export…",
  "cust.erase": "Erase personal data",
  "cust.erase_title": "Erase {name}'s personal data?",
  "cust.erase_body": "Name, contact details, addresses, notes and sign-in details are removed for good. Orders stay for your accounting, without personal details. This can't be undone.",
  "cust.erased": "Personal data erased.",
  "cust.delete": "Delete customer",
  "cust.delete_title": "Delete {name}?",
  "cust.delete_body": "The customer is removed from your store. Customers with orders can't be deleted; erase their data instead.",
  "cust.deleted": "Customer deleted.",

  "cust.import_title": "Import customers",
  "cust.import_hint": "Upload a customer CSV in the standard export format used by most e-commerce platforms. A row needs an email or a phone number.",
  "cust.import_rows": "{n} rows",
  "cust.import_update": "Update customers that already exist (matched by email or phone)",
  "cust.export_title": "Export customers",
  "cust.export_all": "All customers",
  "cust.export_filtered": "Customers matching your filters ({n})",
  "cust.export_note": "Without permission to view contact details, emails and phones are masked. Exports of more than 1,000 customers ask you to confirm it's you.",
  "cust.export_ready": "Your export is ready. The link works for 24 hours.",

  "addr.country": "Country/region",
  "addr.company": "Company",
  "addr.phone": "Phone",

  "merge.title": "Merge customers",
  "merge.action": "Merge",
  "merge.source": "Merged away",
  "merge.target": "Kept",
  "merge.stats": "{orders} orders · {spent}",
  "merge.swap": "Keep the other customer instead",
  "merge.choose": "Choose which details to keep",
  "merge.field.first_name": "First name",
  "merge.field.last_name": "Last name",
  "merge.field.email": "Email",
  "merge.field.phone": "Phone",
  "merge.field.locale": "Language",
  "merge.field.tax_exempt": "Tax exempt",
  "merge.moves": "Orders, addresses, tags, timeline and sign-in methods move to the kept customer.",
  "merge.notes": "Notes are combined; empty details are filled in from the other customer.",
  "merge.consent": "A marketing subscription on either customer is kept.",
  "merge.irreversible": "{name} will be merged away. This can't be undone.",
  "merge.confirm": "Merge customers",

  "privacy.title": "Privacy requests",
  "privacy.intro": "Customers can ask for a copy of their data or for it to be erased. Handle requests within 30 days.",
  "privacy.none": "No requests here.",
  "privacy.kind.export": "Data export",
  "privacy.kind.erase": "Erasure",
  "privacy.status.pending": "Pending",
  "privacy.status.processing": "Processing",
  "privacy.status.completed": "Completed",
  "privacy.status.cancelled": "Declined",
  "privacy.status.failed": "Failed",
  "privacy.source.customer": "Asked by the customer",
  "privacy.source.merchant": "Started by staff",
  "privacy.approve": "Approve",
  "privacy.decline": "Decline",
  "privacy.approve_export": "Export {name}'s data?",
  "privacy.approve_export_body": "We'll build the file; you can download it here for 24 hours and send it to the customer.",
  "privacy.approve_erase": "Erase {name}'s personal data?",
  "privacy.approve_erase_body": "Contact details, addresses and notes are removed for good. Orders stay without personal details. This can't be undone.",

  "seg.title": "Segments",
  "seg.all": "All segments",
  "seg.intro": "Segments group customers by what they do: orders, spend, location, subscriptions. Use them for discounts, emails and exports.",
  "seg.create": "Create segment",
  "seg.new": "New segment",
  "seg.empty": "No segments yet.",
  "seg.default": "Default",
  "seg.customers": "customers",
  "seg.default.new": "New customers",
  "seg.default.returning": "Returning customers",
  "seg.default.vip": "VIP (top 10% spend)",
  "seg.default.at_risk": "At risk",
  "seg.default.email_subscribers": "Email subscribers",
  "seg.default.abandoned_checkouts": "Recovered carts (30 days)",
  "seg.name": "Name",
  "seg.name_placeholder": "e.g. Doha VIPs",
  "seg.query": "Conditions",
  "seg.query_hint": "Write conditions, or build them below.",
  "seg.field": "Field",
  "seg.operator": "Condition",
  "seg.and": "and",
  "seg.join": "Join with",
  "seg.join_and": "AND (all must match)",
  "seg.join_or": "OR (any can match)",
  "seg.add_condition": "Add condition",
  "seg.presets": "Quick dates",
  "seg.soon": "soon",
  "seg.preview": "Preview",
  "seg.preview_empty": "Add a condition to see who matches.",
  "seg.fix_query": "Fix the conditions to see who matches.",
  "seg.of_total": "of {total} customers ({pct}%)",
  "seg.fields": "Fields",
  "seg.fields_hint": "Click a field to add an example.",
  "seg.syntax": "Combine with AND, OR, NOT and parentheses. Dates: 2026-01-31 or relative like -30d, -6m. Text goes in quotes.",
  "seg.view_customers": "View customers",
  "seg.delete_title": "Delete this segment?",
  "seg.delete_body": "Customers aren't affected. Discounts or campaigns using it stop matching anyone.",
  "seg.op.=": "is",
  "seg.op.!=": "is not",
  "seg.op.>": "is greater than",
  "seg.op.>=": "is at least",
  "seg.op.<": "is less than",
  "seg.op.<=": "is at most",
  "seg.op.between": "is between",
  "seg.op.contains": "contains",
  "seg.op.not_contains": "doesn't contain",
  "seg.op.is_null": "is empty",
  "seg.op.is_not_null": "is not empty",
  "seg.rel.-7d": "7 days ago",
  "seg.rel.-30d": "30 days ago",
  "seg.rel.-90d": "90 days ago",
  "seg.rel.-6m": "6 months ago",
  "seg.rel.-1y": "1 year ago",

  "acct.accounts": "Customer accounts",
  "acct.mode.optional": "Optional",
  "acct.mode.optional_hint": "Shoppers can check out as guests or sign in.",
  "acct.mode.required": "Required",
  "acct.mode.required_hint": "Shoppers must sign in to check out (useful for wholesale).",
  "acct.mode.disabled": "Off",
  "acct.mode.disabled_hint": "No sign-in; every order is a guest order.",
  "acct.login": "Sign-in method",
  "acct.method.passwordless": "Email code",
  "acct.method.passwordless_hint": "Shoppers get a 6-digit code by email. No passwords to forget.",
  "acct.method.classic": "Email and password",
  "acct.method.classic_hint": "Shoppers create a password.",
  "acct.theme_note": "Sign-in pages appear in your storefront theme.",

  "tl.marketing": "{channel} marketing: {state}",
  "tl.customer.created": "Customer was created",
  "tl.customer.updated": "Customer details were updated",
  "tl.customer.merged": "{name} was merged into this customer",
  "tl.address.added": "Address was added",
  "tl.address.updated": "Address was updated",
  "tl.address.deleted": "Address was deleted",
  "tl.address.default_changed": "Default address was changed",
  "tl.account.created": "Customer created an account",
  "tl.account.signed_in": "Customer signed in",
  "tl.account.activated": "Customer activated their account",
  "tl.account.invite_sent": "Account invite was sent",
  "tl.account.invite_declined": "Customer declined the account invite",
  "tl.account.disabled": "Account was disabled",
  "tl.account.password_reset": "Customer reset their password",
  "tl.account.profile_updated": "Customer updated their profile",
  "tl.privacy.export_requested": "Data export was requested",
  "tl.privacy.erase_requested": "Data erasure was requested",
  "tl.privacy.export_completed": "Data export is ready",
  "tl.privacy.export_failed": "Data export failed",
  "tl.privacy.erased": "Personal data was erased",
  "cust.bulk.add_tags_title": "Add tags to {n} customers",
  "cust.bulk.remove_tags_title": "Remove tags from {n} customers",
  "cust.bulk.delete_title": "Delete {n} customers?",
  "cust.bulk.delete_body": "Customers with orders are kept: erase their personal data instead. This can't be undone.",
  "cust.bulk.done": "{n} customers updated",
  "cust.bulk.done_skipped": "{n} customers updated. {skipped} with orders were kept.",
} as const;

export default customersEn;
